// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2006":"10b01b76","2725":"10b01b76","3214":"10b01b76","3717":"98ae4d6e","7227":"10b01b76","9692":"63374f1f"}[chunkId] + ".chunk.css";
};